// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"14ca0a70","952":"53f627f1"}[chunkId] + ".chunk.js";
};